import { useEffect } from "react";
import { CustomExceptionHandler, ExceptionHandler } from "../api/customExceptionHandler";

export const useCustomExceptionHandlers = (exceptionHandlers: ExceptionHandler[]): void => {
	useEffect(() => {
		CustomExceptionHandler.setup(exceptionHandlers);
	}, [exceptionHandlers]);
};
